'use client';

import { create } from 'zustand';

type VariantQuantitiesStore = {
  quantities: Record<number, number>;
  setVariantQuantity: (variantId: number, quantity: number) => void;
  getVariantQuantity: (variantId: number, defaultQuantity?: number) => number;
};

export const useVariantQuantitiesStore = create<VariantQuantitiesStore>((set, get) => ({
  quantities: {},
  setVariantQuantity: (variantId, quantity) => {
    set(state => ({
      quantities: {
        ...state.quantities,
        [variantId]: quantity,
      },
    }));
  },
  getVariantQuantity: (variantId, defaultQuantity = 1) => {
    return get().quantities[variantId] ?? defaultQuantity;
  },
}));
